module.exports = __webpack_public_path__ + "media/images/svg/circle-bar-6b0d8ff825d2aeffdbf25f320100abb3.svg";